import { render, staticRenderFns } from "./ClientContractList.vue?vue&type=template&id=0379dcfa&"
import script from "./ClientContractList.vue?vue&type=script&lang=js&"
export * from "./ClientContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports